import { createContext } from 'react'
import { HtmlPortalNode } from 'react-reverse-portal'
import { LinkFunction, LinkLocalProps } from '../../../utilities'

export type CampaignNavConfig = {
	overviewLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	candidatesLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	targetingLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	analyticsLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	invoiceLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	exportLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	accessLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
	settingsLinker: LinkFunction<LinkLocalProps & { campaignId: string }>
}

export type ProvidedCampaignNavConfigContextType = CampaignNavConfig

export const ProvidedCampaignNavConfigContext = createContext<ProvidedCampaignNavConfigContextType>({
	overviewLinker: () => null,
	candidatesLinker: () => null,
	targetingLinker: () => null,
	analyticsLinker: () => null,
	invoiceLinker: () => null,
	exportLinker: () => null,
	accessLinker: () => null,
	settingsLinker: () => null,
})

export type CampaignNavPortalTargetContextType = {
	campaignNavTargetNode: HtmlPortalNode | null
}

export const CampaignNavPortalTargetContext = createContext<CampaignNavPortalTargetContextType>({
	campaignNavTargetNode: null,
})
